import { GridSpaceOpeningsOverlayStackingType } from './grid-space-overlay-stacking-types';

export const GRID_SPACE_ELEVATED_Z_CLASS = 'z-[20]';
export const GRID_SPACE_OPENINGS_OVERLAY_Z_CLASS = 'z-[35]';
export const GRID_SPACE_STATIC_OPENINGS_OVERLAY_Z_CLASS = 'z-[17]';
export const GRID_SPACE_STATIC_OPENINGS_OVERLAY_ELEVATED_Z_CLASS = 'z-[21]';
export const GRID_SPACE_POLYGON_HANDLES_Z_CLASS = 'z-[25]';
export const GRID_SPACE_POLYGON_HANDLES_SELECTED_Z_CLASS = 'z-[30]';

export function zIndexFromClass(zClass: string): number {
  const match = zClass.match(/z-\[(\d+)\]/);
  return match ? Number(match[1]) : 0;
}

export function getGridSpaceOpeningsOverlayZClass({
  interactive,
  spaceElevated
}: GridSpaceOpeningsOverlayStackingType): string {
  if (interactive) {
    return GRID_SPACE_OPENINGS_OVERLAY_Z_CLASS;
  }
  if (spaceElevated) {
    return GRID_SPACE_STATIC_OPENINGS_OVERLAY_ELEVATED_Z_CLASS;
  }
  return GRID_SPACE_STATIC_OPENINGS_OVERLAY_Z_CLASS;
}
